import { render, staticRenderFns } from "./StepExponent.vue?vue&type=template&id=15134730&"
import script from "./StepExponent.vue?vue&type=script&lang=js&"
export * from "./StepExponent.vue?vue&type=script&lang=js&"
import style0 from "./StepExponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports